import { __read, __spread } from "tslib";
/** check is that event preventDefault */
export var checkDefaultPrevented = function (fc) {
    return function (e) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (e.defaultPrevented)
            return;
        fc.apply(void 0, __spread([e], args));
    };
};
